import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable, Subscription } from 'rxjs';
import { DisplayDetailsModalComponent } from '../../../core/modals/display-details/display-details.component';
import { LogCategory, LogPage, LogType, LoggerService } from '../../../core/services/logger.service';
import { ProfileService } from '../../../core/services/profile.service';
import { FacilitiesParkingService } from '../../../services/facilities.parking.services';
import { PeopleService } from '../../../services/people.service';
import { ParkingGrid } from './parking-grid.model';

@Component({
    selector: 'app-facilities-parking',
    templateUrl: './parking.component.html',
    styleUrls: ['./parking.component.scss'],
    standalone: false
})
export class FacilitiesParkingComponent implements OnInit {
    public personTypeaheadResults$: Observable<any[]>;
    public selectedPerson: any;

    constructor(
        private logger: LoggerService,
        private profile: ProfileService,
        private router: Router,
        private facilitiesParkingService: FacilitiesParkingService,
        private modalService: NgbModal,
        public peopleService: PeopleService
    ) {

    }

    private _formSubscription: Subscription;
    permitsArray: Array<ParkingGrid> = [];
    newDynamic: any = {};
    submittingToServer = false;
    parkingRequestNames: string = "<p><strong>Names</strong></p>";
    parkingRequestEmails: string = "<p><strong>Emails</strong></p>";
    parkingRequestNamesEmails: string = "<p><strong>Names and Emails</strong></p>";
    objectKeys = Object.keys;
    objectEntries = null;
    objectValues = Object.values;

    ParkingForm: any = {
        additionalContact: '',
        choice: '',
        startDate: '',
        startTime: '',
        startTimeData: '',
        endDate: '',
        endTimeData: '',
        endTime: '',
        timeList: [],
        numberOfPermits: '',
        reason: '',
        namesAndEmails: ''
    }

    ngOnInit(): void {

        if (!Object.entries) {
            Object.entries = function (obj) {
                var ownProps = Object.keys(obj),
                    i = ownProps.length,
                    resArray = new Array(i); // preallocate the Array
                while (i--)
                    resArray[i] = [ownProps[i], obj[ownProps[i]]];

                return resArray;
            }
        }
        this.objectEntries = Object.entries;
        this.log("ngOnInit", null, LogCategory.Init);
        this.newDynamic = { Name: "", Email: "" };
        this.permitsArray.push(this.newDynamic);
        this.facilitiesParkingService.initializeFormValidationProperities(this.ParkingForm);
        this.facilitiesParkingService.fetchSettingsAndValidate(this.ParkingForm, this.permitsArray);
    }

    ngOnDestroy() {
        this.log("ngOnDestroy", null, LogCategory.Destroy);

        if (!!this._formSubscription)
            this._formSubscription.unsubscribe();

        this.peopleService.typeaheadQuery = '';
    }

    private log(method: string = null, message = null, category: LogCategory = LogCategory.Default): void {
        method = (method) ? '.' + method + '()' : '';
        message = (message) ? message.toString() : '';
        this.logger.try(this.constructor.name + method + ': ' + message, LogType.Page, LogPage.Facilities, category);
    }

    addRow(index) {
        this.newDynamic = { Name: "", Email: "" };
        this.permitsArray.push(this.newDynamic);
        this.validate();
        return true;
    }

    deleteRow(index) {
        if (this.permitsArray.length == 1) {
            return false;
        } else {
            this.permitsArray.splice(index, 1);
            this.validate();
            return true;
        }
    }

    onSubmit(form: NgForm) {
        this.log("onSubmit", "Submitting form to controller.");
        if (this.ParkingForm.choice == 'facilities') {
            this.ParkingForm.numberOfPermits = this.permitsArray.length;
            this.permitsArray.forEach(x => this.parkingRequestNames += ` ${x.Name}<br />`);
            this.permitsArray.forEach(x => this.parkingRequestEmails += `${x.Email}<br />`);
            this.permitsArray.forEach(x => this.parkingRequestNamesEmails += `${x.Name} ${x.Email}<br />`);
            this.ParkingForm.namesAndEmails = this.parkingRequestNames + "<br />" + this.parkingRequestEmails + "<br />" + this.parkingRequestNamesEmails;
        }

        if (this.selectedPerson?.EmailAddress)
            this.ParkingForm.additionalContact = this.selectedPerson.EmailAddress;
        this.selectedPerson = undefined;

        this.submittingToServer = true;
        this._formSubscription = this.facilitiesParkingService.postParkingRequest(this.ParkingForm).subscribe((data) => { this.submittingToServer = false; this.notifySubmitter(data, form) }); //do something with the returned result          
    }

    public notifySubmitter(data: any, form: NgForm): void {
        this.log("notifySubmitter", "Parking Modal Thank you and error form.");
        const modalRef = this.modalService.open(DisplayDetailsModalComponent)
        let title = "Error Creating Parking Request";
        let body = "There was an error creating your request. Please contact AppDevSupport@kenan-flagler.unc.edu.";
        if (data == 'complete') {
            title = "Parking Request Created";
            body = "Thank you for submitting a parking request.  You will receive an email confirmation shortly.";
        }
        modalRef.componentInstance.title = title;
        modalRef.componentInstance.body = body;
        modalRef.componentInstance.okButton = "Close";
        modalRef.result.then((result) => {
            this.close();
        }, (reason) => {
            this.close();
        });

    }

    validate() {
        this.facilitiesParkingService.validateParkingData(this.ParkingForm, this.permitsArray);
    }


    close() {
        this.router.navigate(['/facilities'])
    }

    public triggerSearch(searchString) {
        switch (true) {
            case searchString.length >= 2:
                this.personTypeaheadResults$ = this.peopleService.people;  //  API call for people
                break;
            case searchString.length == 0:
                this.peopleService.typeaheadQuery = undefined;
            default:
                this.personTypeaheadResults$ = null;
                this.peopleService.typeaheadQuery = undefined;
                break;
        }
    }

    //  Selects a person from the typeahead results dropdown
    public selectPerson(person) {
        this.personTypeaheadResults$ = null;
        this.peopleService.typeaheadQuery = person.DisplayNameInternal;
        this.selectedPerson = person;
    }
}
